import axios from 'axios';
const _ = require('lodash');
export default {
    data() {
        return {
            answers: null,
            league: null,
            ready: false,
        };
    },
    async created() {
        const leagueId = this.$route.params.id;
        this.league = (await axios.get(`/api/answers/${leagueId}`)).data;
        this.answers = _.reduce(this.league.questions, (answers, q) => {
            const correctAnswer = _.find(q.answers, { correct: true });
            answers[q._id] = correctAnswer ? correctAnswer._id : null;
            return answers;
        }, {});
        this.ready = true;
    },
    methods: {
        async save() {
            try {
                const leagueId = this.$route.params.id;
                const nextQuestionIds = this.league.questions.filter(q => q.next).map(q => q._id);
                await axios.post(`/api/answers/${leagueId}`, { answers: this.answers, nextQuestionIds });
                alert('Success!');
            }
            catch (e) {
                alert(e);
            }
        },
    },
    components: {
        question_component: require('./question.vue').default,
    },
};
